{{ value ? (value | date : format) : emptyString }}
